import { render } from "./ArticleRelated.vue?vue&type=template&id=67f8e6d5"
import script from "./ArticleRelated.vue?vue&type=script&lang=js"
export * from "./ArticleRelated.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__